var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 70,
    viewBox: "0 0 88 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21H0.621753C0.0110097 21.8477 0.907897 21.8757 3.31241 22.5325L37.0562 31.7504C40.8912 32.798 47.1089 32.798 50.9438 31.7504L84.6876 22.5325C87.0921 21.8757 87.989 21.8477 87.3783 21H88V49.608V49.7555C88 50.8229 87.0343 51.7429 85.2805 52.5573L50.3508 68.7784C46.8434 70.4072 41.1566 70.4072 37.6491 68.7784L2.71945 52.5573C0.965712 51.7429 -1.508e-06 50.6755 0 49.608V21Z",
    fill: "url(#paint0_linear_7_8356)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21H0.621753C0.0110097 21.8477 0.907897 21.8757 3.31241 22.5325L37.0562 31.7504C40.8912 32.798 47.1089 32.798 50.9438 31.7504L84.6876 22.5325C87.0921 21.8757 87.989 21.8477 87.3783 21H88V49.608V49.7555C88 50.8229 87.0343 51.7429 85.2805 52.5573L50.3508 68.7784C46.8434 70.4072 41.1566 70.4072 37.6491 68.7784L2.71945 52.5573C0.965712 51.7429 -1.508e-06 50.6755 0 49.608V21Z",
    fill: "url(#paint1_linear_7_8356)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6363 1.2281C41.1509 -0.409368 46.8491 -0.409368 50.3637 1.2281L85.3641 17.5351C88.8786 19.1726 88.8786 21.8274 85.3641 23.4649L50.3637 39.7719C46.8491 41.4094 41.1509 41.4094 37.6363 39.7719L2.63593 23.4649C-0.878645 21.8274 -0.878644 19.1726 2.63593 17.5351L37.6363 1.2281Z",
    fill: "#219653"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5568 25.4931C49.7831 26.3771 48.5181 27.1089 46.9867 26.9798L29.8315 25.5337C28.6784 25.4365 28.1618 24.62 28.9614 24.1583L46.6065 13.9709L49.5568 25.4931Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0402 15.1778L52.0143 22.4119L52.7089 22.4176L54.8755 22.4476C56.4084 22.5784 57.6765 21.8463 57.4499 20.9612L55.2052 12.1958L54.9038 11.0525C54.729 10.3895 53.3197 10.0951 52.5228 10.5551L49.2935 12.4196L50.0402 15.1778Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_8356",
    x1: -3.11667,
    y1: 41.4975,
    x2: 88,
    y2: 41.4975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.419404,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595068,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_8356",
    x1: -3.11667,
    y1: 41.4975,
    x2: 88,
    y2: 41.4975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.419404,
    stopColor: "#1B7642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#229855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595068,
    stopColor: "#28A45D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWBox);
export default __webpack_public_path__ + "static/media/w-box.a9104ae31adb3b0b3f4961223fa4f163.svg";
export { ForwardRef as ReactComponent };